import React, { Component } from 'react';
import CrossfadeImage from 'react-crossfade-image';
import daniel_carly2 from '../assets/images/Carly_Daniel2.jpg';
import daniel_carly8 from '../assets/images/Carly_Daniel8.jpg';
import daniel_carly1 from '../assets/images/Carly_Daniel1.jpg';
import daniel_carly3 from '../assets/images/Carly_Daniel3.jpg';
import daniel_carly4 from '../assets/images/Carly_Daniel4.jpg';
import daniel_carly5 from '../assets/images/Carly_Daniel5.jpg';
import daniel_carly6 from '../assets/images/Carly_Daniel6.jpg';
import daniel_carly7 from '../assets/images/Carly_Daniel7.jpg';
import daniel_carly9 from '../assets/images/Carly_Daniel9.jpg';
import daniel_carly10 from '../assets/images/Carly_Daniel10.jpg';
import daniel_carly11 from '../assets/images/Carly_Daniel11.jpg';
import daniel_carly12 from '../assets/images/Carly_Daniel12.jpg';
import daniel_carly13 from '../assets/images/Carly_Daniel13.jpg';
import daniel_carly14 from '../assets/images/Carly_Daniel14.jpg';
import daniel_carly15 from '../assets/images/Carly_Daniel15.jpg';

import firebase from './firebase';

const database = firebase.database();

class Countdown extends Component {
	constructor(props) {
		super(props);

		this.state = {
			days: null,
			currentImage: 0
		};
	}

	componentDidMount() {
		let countDownDays;
		database
			.ref('/WeddingDate')
			.once('value', function(snap) {
				let date1 = new Date(String(snap.val()));
				let date2 = new Date();

				var diff = Math.floor(date1.getTime() - date2.getTime());
				var day = 1000 * 60 * 60 * 24;

				countDownDays = Math.floor(diff / day);
			})
			.then((data) => {
				this.state = this.setState({ days: countDownDays });
				this.currentImage = setInterval(
					() =>
						this.setState(function() {
							if (this.state !== undefined) {
								return { currentImage: this.getRandomImageId(this.state.currentImage) };
							} else {
								console.log('ZERO')
								return { currentImage: 0 };
							}
						}),
					8000
				);
			});
	}
	getRandomImageId(value) {
		if (value < 14) {
			return (value += 1);
		} else {
			return 0;
		}
	}
	render() {
		const countDown = this.state;
		const images = [
			daniel_carly2,
			daniel_carly8,
			daniel_carly1,
			daniel_carly10,
			daniel_carly3,
			daniel_carly4,
			daniel_carly5,
			daniel_carly6,
			daniel_carly7,
			daniel_carly9,
			daniel_carly11,
			daniel_carly12,
			daniel_carly13,
			daniel_carly14,
			daniel_carly15
		];
		return (
			<div id="main" className="countdown-container">
				<span className="image fit">
					<CrossfadeImage src={images[this.state.currentImage]} duration={3000} alt="" />
					<div className="centered" style={{ height: '100%', width: '100%' }}>
						<h1 style={{ color: 'white', marginTop: 200 }}> Carly & Daniel</h1>
						{countDown.days === 0 && <h4 style={{ color: 'white' }}> Today is the day!</h4>}
						{countDown.days === 1 && <h4 style={{ color: 'white' }}> Tomorrow is the day!</h4>}
						{countDown.days > 0 && <h4 style={{ color: 'white' }}> {countDown.days} days to go!</h4>}
					</div>
				</span>
			</div>
		);
	}
}
export default Countdown;
